const cache = new Map();

export const getCachedVerificacion = (cuit) => {
  const key = String(cuit || "").replace(/\D/g, "");
  return key ? cache.get(key) : undefined;
};

export const setCachedVerificacion = (cuit, data) => {
  const key = String(cuit || "").replace(/\D/g, "");
  if (key) cache.set(key, data);
};

export const invalidateListaNegraCache = () => {
  cache.clear();
};
